module.exports = __webpack_public_path__ + "static/yaroslav_kihtan-8621ec39ea48a80a71a1a80fb8ea387e.png";